import { createFileRoute } from '@tanstack/react-router'

import { CataloguePage } from '@/features/cards/catalogue-page'
import { catalogueFilters } from '@/features/cards/catalogue-filters'

export const Route = createFileRoute('/_app/catalogue')({
    validateSearch: catalogueFilters.parse,
    component: CataloguePage,
    staticData: { crumb: 'Catalogue' }
})
